import React, { useState, useMemo, useEffect } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Input,
  Label,
  Button
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import api from "../../../utils/api"


const ReservationOffcanvas = ({
  isOpen,
  toggle,
  tenant,
  items
}) => {

  const [eventName, setEventName] = useState("");
  const [eventType, setEventType] = useState("");
  const [pax, setPax] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [advance, setAdvance] = useState(0);

  /* 🔥 AUTO COST CALCULATION */
  const { perPlateCost, totalAmount, remaining } = useMemo(() => {

    let perPlate = 0;

    selectedItems.forEach(item => {
      perPlate += item.price / 3; // 1 full plate serves 3 pax
    });

    const total = perPlate * pax;
    const remain = total - advance;

    return {
      perPlateCost: perPlate.toFixed(2),
      totalAmount: total.toFixed(2),
      remaining: remain.toFixed(2)
    };

  }, [selectedItems, pax, advance]);

  /* 🔥 SAVE RESERVATION */
  const handleSave = async () => {
  try {

    if (!eventName || !startDate || !endDate) {
      alert("Please fill all required fields");
      return;
    }

    const payload = {
      title: eventName,
      type: eventType || "General",
      start: new Date(startDate).toISOString(),
      end: new Date(endDate).toISOString(),
      floor: 1,
      table: 1,
      numberOfPax: Number(pax) || 0,
      foodItems: selectedItems.map(i => ({
        itemId: i.id,
        name: i.name,
        price: Number(i.price)
      })),
      totalAmount: Number(totalAmount) || 0,
      advancePayment: Number(advance) || 0
    };

    console.log("Sending reservation:", payload);

    const res = await api.post("/guest/reservations", payload, {
      params: { tenant }
    });

    console.log("Reservation response:", res.data);

    alert("Reservation created successfully");
    toggle();

  } catch (err) {
    console.error("Reservation save error:", err.response?.data || err);
    alert(err.response?.data?.message || "Failed to save reservation");
  }
};

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="bottom"
      style={{ height: "90vh" }}
    >
      <OffcanvasHeader toggle={toggle}>
        Event Reservation
      </OffcanvasHeader>

      <OffcanvasBody className="overflow-auto">

        <Label>Event Name</Label>
        <Input value={eventName} onChange={e => setEventName(e.target.value)} />

        <Label className="mt-3">Event Type</Label>
        <Input type="select" value={eventType} onChange={e => setEventType(e.target.value)}>
          <option value="">Select</option>
          <option>Birthday</option>
          <option>Corporate</option>
          <option>Wedding</option>
        </Input>

        <Label className="mt-3">Number of Pax</Label>
        <Input type="number" value={pax} onChange={e => setPax(Number(e.target.value))} />

        <Label className="mt-3">Event Date</Label>
        <div className="d-flex gap-2">
          <DatePicker
            selected={startDate}
            onChange={date => setStartDate(date)}
            className="form-control"
            placeholderText="Start"
          />
          <DatePicker
            selected={endDate}
            onChange={date => setEndDate(date)}
            className="form-control"
            placeholderText="End"
          />
        </div>

        <Label className="mt-3">Select Menu Items</Label>
        {items
          .filter(i => i.menuGroup === "restaurant")
          .map(i => (
            <div key={i.id} className="d-flex justify-content-between align-items-center mt-2">
              <span>{i.name} - ₹{i.fullPrice}</span>
              <Button
                size="sm"
                color="success"
                onClick={() =>
                  setSelectedItems(prev => [
                    ...prev,
                    { id: i.id, name: i.name, price: i.fullPrice }
                  ])
                }
              >
                Add
              </Button>
            </div>
          ))}

        <div className="mt-3 border p-3 rounded">
          <p>Per Plate: ₹{perPlateCost}</p>
          <p>Total: ₹{totalAmount}</p>
          <p>Remaining: ₹{remaining}</p>
        </div>

        <Label className="mt-3">Advance Payment</Label>
        <Input
          type="number"
          value={advance}
          onChange={e => setAdvance(Number(e.target.value))}
        />

        <Button
          color="primary"
          className="w-100 mt-4"
          onClick={handleSave}
        >
          Save Reservation
        </Button>

      </OffcanvasBody>
    </Offcanvas>
  );
};

export default ReservationOffcanvas;